import { hasCapability } from '../tours/index.js';

/**
 * @param {import('./matchRoute.js').PageTourStep[]} steps
 * @param {import('../tours/types.js').TourUser} user
 */
export function filterPageTourSteps(steps, user) {
  return steps.filter((step) => {
    if (step.roles?.length && !step.roles.includes(user.role)) {
      return false;
    }
    if (step.capabilities?.length && !step.capabilities.every((c) => hasCapability(user, c))) {
      return false;
    }
    if (step.when && !step.when(user)) {
      return false;
    }
    return true;
  });
}

/**
 * @param {string | null | undefined} selector
 * @param {number} timeoutMs
 */
function waitForElement(selector, timeoutMs) {
  if (!selector) {
    return Promise.resolve(null);
  }
  const existing = document.querySelector(selector);
  if (existing) {
    return Promise.resolve(existing);
  }
  return new Promise((resolve) => {
    const start = Date.now();
    const tick = () => {
      const el = document.querySelector(selector);
      if (el) {
        resolve(el);
        return;
      }
      if (Date.now() - start > timeoutMs) {
        resolve(null);
        return;
      }
      requestAnimationFrame(tick);
    };
    tick();
  });
}

/**
 * Drop steps whose target is not on the page (e.g. gated UI).
 * @param {import('./matchRoute.js').PageTourStep[]} steps
 */
export async function filterStepsByDom(steps) {
  const visible = [];
  for (const step of steps) {
    if (!step.selector) {
      visible.push(step);
      continue;
    }
    const el = await waitForElement(step.selector, 1200);
    if (el) {
      visible.push(step);
    }
  }
  return visible;
}
